import { deepSet } from "../utils";
import { Dataset, DatasetType } from "../types";

export interface DatasetState {
    currentDatasetId: Dataset["id"];
    datasetsById: Record<Dataset["id"], Dataset>;
    getCurrentDataset: () => Dataset;
    getCurrentProjectType: () => DatasetType | null;
    getDatasetIdByUrl: (url: string) => Dataset["id"];
    setCurrentDatasetId: (id: string) => any;
    addDatasetById: (ds: Dataset) => any;
}

function datasetReducer(set, get) {
    return {
        // values
        currentDatasetId: "",
        datasetsById: {},

        // getters
        getCurrentDataset() {
            return window.currentDataset as Dataset;
        },
        getCurrentProjectType() {
            return (window.currentDataset?.type as DatasetType) || null;
        },
        getDatasetIdByUrl(url) {
            return get().datasetsByUrl[url]?.id;
        },

        // mutators
        setCurrentDatasetId(currentDatasetId) {
            window.currentDataset = get().datasetsById[currentDatasetId];
            return set(() => ({ currentDatasetId }), false, "setDataset");
        },
        addDatasetById: (ds) => {
            window.datasetUrls = Object.assign(window.datasetUrls || {}, { [ds.id]: ds });
            return set(deepSet("datasetsById", { [ds.id]: ds }), false, "addDatasetById");
        }
    };
}

export function buildDatasetStore(set, get, api) {
    return { ...datasetReducer(set, get) };
}
